import { useEffect, useRef } from 'react';

/**
 * Calls `callback` every animation frame while mounted. Use it to update the DOM directly
 * (refs, data attributes) for playback visuals; don't set React state from it (section 2.3).
 */
export function useAnimationFrame(callback: () => void, enabled = true): void {
  const ref = useRef(callback);
  useEffect(() => {
    ref.current = callback;
  });

  useEffect(() => {
    if (!enabled) return;
    let raf = 0;
    const tick = () => {
      ref.current();
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
    };
  }, [enabled]);
}
